import { ContentBox } from "@msuite/ui/app-shell";
import { useTranslation } from "@msuite/ui/localization";
import { DataTable } from "@msuite/ui/table";
import { Tabs } from "@msuite/ui/tabs";
import RenderHooks from "render-hooks";
import { usePartnerships } from "@/hooks/use-partnerships";
import ExternalServices from "@/sites/external-services/external-services";
import { BookingReviews } from "@/sites/partners/booking-reviews";
import { PartnersMenu } from "./partners-menu";
import { columns } from "./table-config";

const hooks = { usePartnerships };

export function Partners() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentBox bottomPadding="none">
			<Tabs
				panelKey="partners-tabs"
				groups={[
					{
						name: "partners",
						panels: [
							{
								label: t("partners.partners"),
								errors: null,
								cyId: "partners-tab",
								panel: () => (
									<RenderHooks hooks={hooks}>
										{({ usePartnerships }) => {
											const { data, isLoading, queryKey, refetch } = usePartnerships("both", [
												"active",
												"pending",
												"inactive",
											]);
											return (
												<DataTable
													data={data ?? []}
													isLoading={isLoading}
													columns={columns}
													menu={<PartnersMenu />}
													queryKey={queryKey}
													persistenceKey="partners-table"
													refetch={refetch}
												/>
											);
										}}
									</RenderHooks>
								),
							},
							{
								label: t("partners.submit_bookings"),
								errors: null,
								panel: () => <ExternalServices />,
								cyId: "external-services-tab",
							},
							{
								label: t("partners.review_bookings"),
								errors: null,
								panel: () => <BookingReviews />,
								cyId: "booking-reviews-tab",
							},
						],
					},
				]}
			/>
		</ContentBox>
	);
}
